<template>
  <div class="map-box">

    <!-- 国内 -->
    <div v-if="m2&&from===1" >
      <baidu-map class="map" NavigationControlType='BMAP_NAVIGATION_CONTROL_LARGE' ak="UwrDLDbFuAtRiZXGzkgx4c3m"
                 :scroll-wheel-zoom="true" @ready="handler">
        <bm-driving
          :start="{lng: m1, lat: m2}"
          :end="{lng:lng, lat: lat}"
          :panel="false"
          :auto-viewport="true"
          v-if="!isWalking"
        ></bm-driving>
        <bm-view class="map">
        </bm-view>
        <bm-walking :start=" {lng: m1, lat: m2}" :end=" {lng: lng, lat:lat}" :panel="false" :auto-viewport="true"
                    v-if="isWalking"></bm-walking>

        <bml-marker-clusterer :averageCenter="true" :auto-viewport="true" v-if="points&&points.length>0">
            <bm-marker v-for="(marker,index) of points" :key="marker.lng+index" :position="{lng: marker.lng, lat: marker.lat}" v-if="marker.lng!=lng&&marker.lat!=lat" ></bm-marker>
        </bml-marker-clusterer>

      </baidu-map>
    </div>

    <!-- 海外 -->
    <div v-if="from===0" class="map-area">

      <baidu-map class="map" ak="UwrDLDbFuAtRiZXGzkgx4c3m" :center="center" :zoom="18" @ready="frHandler">
        <bm-marker :position="center">
          <!-- <bm-label :content="content"  :labelStyle="labelStyle" :offset="{width: -60, height: 30}" /> -->
        </bm-marker>
      </baidu-map>
    </div>

    <!-- 周围地点 -->
    <div class="map-view-trasp">
      <ul class="lmy-map-menu" id="swipeCalendar">
        <li :class="activePage=='page1'?'menu-list active':'menu-list'" @click="selectPage('page1','交通')"><span>交通</span></li>
        <li :class="activePage=='page2'?'menu-list active':'menu-list'" @click="selectPage('page2','景点')"><span>景点</span></li>
        <li :class="activePage=='page3'?'menu-list active':'menu-list'" @click="selectPage('page3','美食')"><span>美食</span></li>
        <li :class="activePage=='page4'?'menu-list active':'menu-list'" @click="selectPage('page4','购物')"><span>购物</span></li>
      </ul>
      <ul class="lmy-map-content" >
        <li v-if="!lmList.length||lmList.length<=0">没有相关地点</li>
        <li :class="lm.active?'active':''" v-for="(lm,i) in lmList" :key="i" v-else>
          <p class="title">{{lm.Name}}</p>
          <p class="detail">{{lm.Info}}</p>
          <span class="nav" @click="clickHandler({lng:lm.LON,lat:lm.LAT},lm,lmList)" v-if="from==1" >导航</span>
        </li>

        
      </ul>
    </div>

  </div>
</template>

<script>
  import {BmView, BaiduMap,MarkerClusterer, BmMarker, BmLabel, BmPointCollection, BmWalking, BmDriving} from 'vue-baidu-map';

  export default {

    components: {
      BaiduMap,
      BmView,
      BmMarker,
      BmLabel,
      BmPointCollection,
      MarkerClusterer,
      BmWalking,
      BmDriving
    },
    props:{
      mapData:{
        type:Object,
        default:()=>{
          return {}
        }
      }

    },
    
    data() {
        return {
            center: {lng: 116.404, lat: 39.915},
            lat:'',
            lng: '',
            m1:'',
            m2:'',
            from: 1,
            isWalking: false,
            points: [],
            Lamndmarks:JSON.parse(this.dao.get('mapLamndmarks')),
            lmList:'',
            activePage:'page1',
            showListNum: 0,
            content: ''
        }
    },
    methods: {
      frHandler({BMap, map}) {

        this.selectPage('page1','交通')
        this.center={lng: this.m1, lat: this.m2}


      },
      selectPage(page,name){
        this.activePage=page;
        this.showListNum=this.showListNum||3;
        this.lmList=this.Lamndmarks[name]||'';
        this.points=[];
        this.lat=Number(this.$route.query.lat);
        this.lng=Number(this.$route.query.lng);
        var list=this.lmList;
        for(var i=0;i<list.length;i++){
          this.points.push({lng:list[i].LON,lat:list[i].LAT})
        }
      },
      handler({BMap, map}) {
       
          this.selectPage('page1','交通')

      },
      clickHandler(e,lm,list) {

        this.$nextTick(function () {
          for(var i=0;i<list.length;i++){
            list[i].active=false;

          }
          this.$set(lm,'active',lm.active?false:true);
        });
        this.lng=e.lng;
        this.lat=e.lat;
      },

      initSwipe() {
        var that = this;
        var div = document.getElementById('swipeCalendar');
        div.addEventListener('touchstart', touch, false);
        div.addEventListener('touchend', touch, false);
        var pagey;
        function touch(event) {
          var event = event || window.event;
          switch (event.type) {
            case "touchstart":
              pagey = event.touches[0].clientY;
              break;
            case "touchend":
              if (event.changedTouches[0].clientY - pagey > 10) {
                // that.prev();
                that.touchDown();
              } else if (event.changedTouches[0].clientY - pagey < -10) {
                // that.next();
                that.touchTop();
              }
              break;
            case "touchmove":
              event.preventDefault();
              break;
          }
        }
      },
      touchTop() {

        switch (this.showListNum) {
          case 0:
            this.showListNum = 3;
            break;
          case 3:
            this.showListNum = 6;
            break;
        }
       
      },
      touchDown() {
        switch (this.showListNum) {
          case 6:
            this.showListNum = 3;
            break;
          case 3:
            this.showListNum = 0;
            break;
        }
      }
    },
    mounted() {
      
        this.lat= Number(this.mapData.lat);
        this.lng= Number(this.mapData.lng);
        this.m1=  Number(this.mapData.m1);
        this.m2=  Number(this.mapData.m2);
        this.from=Number(this.mapData.from);
    }
  }

</script>

<style scoped>
  .map-box{
    position: relative;
    height: 400px !important;
  }
  .map-view-trasp{
    position: absolute;
    bottom: 0!important;
    width: 100%;
    overflow: hidden;
  }
  .map {
    width: 100%;
    height: 400px;
    position: relative;
  }
  .lmy-map-content{
      height: 3rem;
      background-color: #fff
  }
  .lmy-map-content>li.active{
    background-color: #fff3f3;

  }


</style>



// WEBPACK FOOTER //
// src/components/common/cmpnt/mapView.vue